<div
  class="input input--{{ view }}"
  [ngClass]="{ 'input--disabled': readonly || disabled }"
>
  <ng-container *ngIf="label">
    <label
      class="input__label"
      [for]="name"
    >{{ label }}{{required ? '*' : ''}}</label>
  </ng-container>
  <input
    class="input__control"
    autocomplete="off"
    [id]="name"
    [name]="name"
    [type]="type"
    [placeholder]="placeholder"
    [mask]="mask || ''"
    [required]="required"
    [readonly]="readonly"
    [disabled]="disabled"
    [ngClass]="{
      'input__control--success': success,
      'input__control--error': error
    }"
    [(ngModel)]="value"
  />
  <ng-container *ngIf="helper">
    <p class="input__helper">{{ helper }}</p>
  </ng-container>
</div>
